var _rect, _rect2, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceMeAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 41,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 9,
    height: 21,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7279,
    y: 8,
    width: 18,
    height: 18,
    transform: "rotate(45 12.7279 8)",
    fill: "url(#pattern1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_223",
    transform: "matrix(0.0111111 0 0 0.0102981 0 0.0365854)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_2_223",
    transform: "matrix(0 -0.0111111 0.0111111 0 0 1)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_223",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACE0lEQVR4nO2dPU5CQRgAt1LPoJZUdGQnhI5T2Gp2tRQt9YT+VOhRDDZWmI0UFsYAEt+b8E2yFS95M182CxWbUhAEQRAEgZ7p9OII6i2UZ6jvUJc9W83pKedyMxjMDpOR8fjqFMprD4a5XGflXF+ac/LtZM+Q+TZs1c7+Oi66HxzbDXuWLKzO5KVzlcdkAcpCPOhFstD9sOqfVrLQ9aCIQdfOh7gXOzr1DIunPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4Aiac+AImnPgCJpz4AiefGAWy4RqN6vO47J5Pzk129N1nYVXDO9W7dd+Zc7mPQbD3sjzbs33Z2+6w9057dw0F7/3o+5/qWLMRlCv9Eu6nHu6Mvr5OFdmlMuzxGeGzMh8Ozg2SiXYdkGnbOdd5+IiYjq509a5fI9PMLsixyLg/tuNDt5CAIgiAIgvQTn1ckrq19mEJjAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_2_223",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACyElEQVR4nO3cu2sUQRwH8NHCV+Oj0EIEH2cTuAuX7++y26UQQdA2jYTczm9DQPDVaiNa+S/YWitokdZCo6KQCJZaaekjhUa0UE/G8/CMp9zt42Zv7/uBX72/+TI3GXZnYgwRERERERERERERERERUckEQXQUmD/iu4/SCoJ4n4hdFtGWK0AfitjDvvsqHcDe7oT8u+waoCd991YqIrr+d9A/w/4G6FVjrmz23WMpSM+Q/wj8Xq02t9d3n2MQtLp1+zVgA9+9lj5oac/sLyJ6wXe/YxC0/prd9iawuMN336UPWtphr05PLxzy3Xvpg5b2uv2u0YhP+O6/9EFLu76L2OvcAuYfdKeWqtUzu/t53tiSbIJ2u5JXIlHD93jGIGh16/ZnIFrwPabSBy1dW8AwnN3ue2ylD1ratRIEzYO5Nj8z09wmYi8C+lTEfspxMK2C15tGQ4/lErJIdEBEnxdgkK0iFKBfRaJLxphNGc9khiy9Q78DLO7MJGi3XPieQVLgAvQFEFVTB91ek/0PSIpd60B8Ou2M/liAgbRGoQC9MTExuyVh0P4HICNU7kNwoq83vhuXkSy7zKBlOGHX63GFM1qGsYQMeHDH/89QR7C4dLSGEPJjd1IqwRrN7Z0MZ3tnn/j/KWrBy71ks3MmDcCe9z8QLXDZl/V6XDNpVSrntgL6zP+AtHAF2LuTk81dJithOL+fYeuG16R6OdPXpB1ukQfis4B9BNgPvmeTeCv7FoiPZx7wKJL8gl7haaYuOa3H/Di7UbYB87jBP2W4HvMAzRCCXgrDeM9/HzTuJF3APOTYrxR/8N7z2O4AEoa8yruIA0qydePVigQG2FXwslAafe6Pef0trT5mMi905ntF2W3d9Brvp2QEsLd6zOK1qSl7KqtnkDHGnRQS0QddQd/n/+3IkTvEwteaRERERERERERERERERGQK5AcUWEjdthEeBwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceMeAndroid);
export default __webpack_public_path__ + "static/media/price-me-android.9695043157756e1313f1cec0abc6eeba.svg";
export { ForwardRef as ReactComponent };